export enum RuleType {
    Cut = 'Cut',
    Crease = 'Crease',
    Perfo = 'Perfo',
    CutCrease = 'CutCrease',
}
